
/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CustomerNotificationPreferences,
  FreelancerNotificationPreferences,
} from '../models';
import {
    CustomerNotificationPreferencesFromJSON,
    CustomerNotificationPreferencesToJSON,
    FreelancerNotificationPreferencesFromJSON,
    FreelancerNotificationPreferencesToJSON,
} from '../models';

export interface GetUnloggedCustomerNotificationPreferencesRequest {
    uid: string;
}

export interface GetUnloggedFreelancerNotificationPreferencesRequest {
    uid: string;
}

export interface UpdateUnloggedCustomerNotificationPreferencesRequest {
    uid: string;
    customerNotificationPreferences: CustomerNotificationPreferences;
}

export interface UpdateUnloggedFreelancerNotificationPreferencesRequest {
    uid: string;
    freelancerNotificationPreferences: FreelancerNotificationPreferences;
}

/**
 * 
 */
export class AccountUnloggedResourceApi extends runtime.BaseAPI {

    /**
          */
    async getUnloggedCustomerNotificationPreferencesRaw(requestParameters: GetUnloggedCustomerNotificationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CustomerNotificationPreferences>> {
        if (requestParameters['uid'] == null) {
            throw new runtime.RequiredError(
                'uid',
                'Required parameter "uid" was null or undefined when calling getUnloggedCustomerNotificationPreferences().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['uid'] != null) {
            queryParameters['uid'] = requestParameters['uid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CustomerNotificationPreferences>({
            path: `/account/api/notifications-preferences/customer/unlogged`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CustomerNotificationPreferencesFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getUnloggedCustomerNotificationPreferences(requestParameters: GetUnloggedCustomerNotificationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CustomerNotificationPreferences> {
        const response = await this.getUnloggedCustomerNotificationPreferencesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getUnloggedFreelancerNotificationPreferencesRaw(requestParameters: GetUnloggedFreelancerNotificationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerNotificationPreferences>> {
        if (requestParameters['uid'] == null) {
            throw new runtime.RequiredError(
                'uid',
                'Required parameter "uid" was null or undefined when calling getUnloggedFreelancerNotificationPreferences().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['uid'] != null) {
            queryParameters['uid'] = requestParameters['uid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerNotificationPreferences>({
            path: `/account/api/notifications-preferences/freelancer/unlogged`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerNotificationPreferencesFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getUnloggedFreelancerNotificationPreferences(requestParameters: GetUnloggedFreelancerNotificationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerNotificationPreferences> {
        const response = await this.getUnloggedFreelancerNotificationPreferencesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async updateUnloggedCustomerNotificationPreferencesRaw(requestParameters: UpdateUnloggedCustomerNotificationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['uid'] == null) {
            throw new runtime.RequiredError(
                'uid',
                'Required parameter "uid" was null or undefined when calling updateUnloggedCustomerNotificationPreferences().'
            );
        }

        if (requestParameters['customerNotificationPreferences'] == null) {
            throw new runtime.RequiredError(
                'customerNotificationPreferences',
                'Required parameter "customerNotificationPreferences" was null or undefined when calling updateUnloggedCustomerNotificationPreferences().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['uid'] != null) {
            queryParameters['uid'] = requestParameters['uid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/notifications-preferences/customer/unlogged`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerNotificationPreferencesToJSON(requestParameters['customerNotificationPreferences']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async updateUnloggedCustomerNotificationPreferences(requestParameters: UpdateUnloggedCustomerNotificationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUnloggedCustomerNotificationPreferencesRaw(requestParameters, initOverrides);
    }

    /**
          */
    async updateUnloggedFreelancerNotificationPreferencesRaw(requestParameters: UpdateUnloggedFreelancerNotificationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['uid'] == null) {
            throw new runtime.RequiredError(
                'uid',
                'Required parameter "uid" was null or undefined when calling updateUnloggedFreelancerNotificationPreferences().'
            );
        }

        if (requestParameters['freelancerNotificationPreferences'] == null) {
            throw new runtime.RequiredError(
                'freelancerNotificationPreferences',
                'Required parameter "freelancerNotificationPreferences" was null or undefined when calling updateUnloggedFreelancerNotificationPreferences().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['uid'] != null) {
            queryParameters['uid'] = requestParameters['uid'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/notifications-preferences/freelancer/unlogged`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FreelancerNotificationPreferencesToJSON(requestParameters['freelancerNotificationPreferences']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async updateUnloggedFreelancerNotificationPreferences(requestParameters: UpdateUnloggedFreelancerNotificationPreferencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUnloggedFreelancerNotificationPreferencesRaw(requestParameters, initOverrides);
    }

}
